import React, { useEffect, useState } from 'react'
import { postObtenerTodosLosConsentimientosInformadosUsuario } from '../../services/PaginaRuta'
import ModalEditarConsentimientoInformado from './ModalEditarConsentimientoInformado'
import ModalConfirmarDescargaPDFConsentimientoInformado from './ModalConfirmarDescargaPDFConsentimientoInformado'
import Loading from '../Loading'
import ModalInhabilidarConsentimientoInformado from './ModalInhabilidarConsentimientoInformado'

const ModalConsentimientosDeUnUsuario = ({setmodalOnConsentimientoInformado, user}) => {
    const [dataConsentimientosUser, setdataConsentimientosUser]=useState([])
    const [modalOnEditarYFirmarConsentimientoInformado, setmodalOnEditarYFirmarConsentimientoInformado]=useState(false)
    const [dataUnConsentimientoInformado, setdataUnConsentimientoInformado]=useState({})
    const [descargarPDFConsentimientoInformado, setdescargarPDFConsentimientoInformado]=useState(false)
    const [loading, setloading]=useState(true)
    const [actualizarData, setactualizarData]=useState('')
    const [modalOnInhabilitarConsentimiento, setmodalOnInhabilitarConsentimiento]=useState(false)

    const handleCancelarClick=()=>{
        setmodalOnConsentimientoInformado(false)
    }

    useEffect(()=>{
        const consultar={
            "tpdocumento": user.TFTDoc,
            "documento": user.MPCedu
        }
        setloading(false)
        postObtenerTodosLosConsentimientosInformadosUsuario(consultar).then((res)=>{
            //console.log(res.data, 'consentimiento user')
            setloading(true)
            setdataConsentimientosUser(res.data)
        })
    },[actualizarData])

    const handleOnclickFirmaConsentimientoInformado=(item)=>{
        setdataUnConsentimientoInformado(item)
        setmodalOnEditarYFirmarConsentimientoInformado(true)
    }

    const handleOnClickDescargarPDF=(item)=>{
      setdataUnConsentimientoInformado(item)
      setdescargarPDFConsentimientoInformado(true)
    }

    const handleOnclickInhabilitar=(item)=>{
      setdataUnConsentimientoInformado(item)
      setmodalOnInhabilitarConsentimiento(true)
    }
    
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
          <h5
            className="text-xl font-medium leading-normal text-white"
            id="exampleModalScrollableLabel"
          >
            Consentimientos
          </h5>
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative p-2">            
            
            <div className="flex py-2 text-left">
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo de Documento 
                </label>
                <div className="flex">
                  <input
                   defaultValue={user.TFTDoc}
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Número Documento 
                </label>
                <div className="flex">
                  <input
                    defaultValue={user.MPCedu}
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Nombre
                </label>
                <div className="flex">
                  <input
                    defaultValue={user.MPNOMC}
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  {/* <button
                    type="submit"
                    className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Buscar
                  </button> */}
                </div>
              </div>
            </div>
            
          
          <div className="flex flex-col rounded-none">
            <div className="overflow-x-auto ">
              <div className="py-2 inline-block min-w-full ">
                <div className="overflow-hidden">
                  <table className="min-w-full text-center bg-gray-200 ">
                    <thead className="">
                      <tr>
                      <th
                          scope="col"
                          
                        >
                          
                        </th>
                        <th
                          scope="col"
                          
                        >
                          
                        </th>
                        <th
                          scope="col"
                          
                        >
                          
                        </th>
                        <th
                          scope="col"
                          
                        >
                          
                        </th>
                      <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Codigo
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Nombre
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Fecha
                        </th>
                        
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Firmo acudiente?
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Firmo Medico?
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Firmo Paciente?
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Firmo Otro?
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>

                    
                    {
                      loading?
                        dataConsentimientosUser.map((item, index)=>(
                            <tr className="divide-y divide-slate-700 " key={index}>
                                <td></td>
                                {
                                  item.Activo === 'Si'?
                                  <td className="text-xs text-gray-900 font-medium  py-1 whitespace-pre-wrap">
                                    <button type="button"
                                        onClick={()=>handleOnclickFirmaConsentimientoInformado(item)}
                                        className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                                        Firma
                                    </button>
                                </td>
                                :
                                <td className="text-xs text-gray-900 font-medium  py-1 whitespace-pre-wrap"></td>
                                }
                                
                                <td className="text-xs text-gray-900 font-medium  py-1 whitespace-pre-wrap">
                                    <button type="button"
                                        onClick={()=>handleOnClickDescargarPDF(item)}
                                        className="mx-2 inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight whitespace-nowrap rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                                        Descargar PDF
                                    </button>
                                </td>
                                <td className="text-xs text-gray-900 font-medium  py-1 whitespace-pre-wrap">
                                    <button type="button"
                                        onClick={()=>handleOnclickInhabilitar(item)}
                                        className="mx-2 inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight whitespace-nowrap rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                                        Inhabilitar 
                                    </button>
                                </td>
                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap">
                                    {item.codigo_consentimiento}
                                    
                                </td>
                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap text-left">
                                    {item.nombre_consentimiento}
                                    
                                </td>
                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap text-left">
                                    {item.fecha}
                                    
                                </td>
                                <td className="text-xs text-gray-900 font-medium whitespace-pre-wrap text-center align-middle h-full">
                                  {item.firmaacudiente === 'Si' ? (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        {/* Círculo de fondo */}
                                        <circle cx="50" cy="50" r="50" fill="#4caf50" />
                                        {/* Línea de verificación */}
                                        <polyline
                                          points="30,50 45,65 70,40"
                                          fill="none"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        <circle cx="50" cy="50" r="50" fill="#ff7043" />
                                        <line
                                          x1="35"
                                          y1="35"
                                          x2="65"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="65"
                                          y1="35"
                                          x2="35"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </td>

                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap ">
                                    {/* {item.firmamedico} */}
                                    {item.firmamedico === 'Si' ? (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        {/* Círculo de fondo */}
                                        <circle cx="50" cy="50" r="50" fill="#4caf50" />
                                        {/* Línea de verificación */}
                                        <polyline
                                          points="30,50 45,65 70,40"
                                          fill="none"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        <circle cx="50" cy="50" r="50" fill="#ff7043" />
                                        <line
                                          x1="35"
                                          y1="35"
                                          x2="65"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="65"
                                          y1="35"
                                          x2="35"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </td>
                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap ">
                                    {/* {item.firmapaciente} */}
                                    {item.firmapaciente === 'Si' ? (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        {/* Círculo de fondo */}
                                        <circle cx="50" cy="50" r="50" fill="#4caf50" />
                                        {/* Línea de verificación */}
                                        <polyline
                                          points="30,50 45,65 70,40"
                                          fill="none"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        <circle cx="50" cy="50" r="50" fill="#ff7043" />
                                        <line
                                          x1="35"
                                          y1="35"
                                          x2="65"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="65"
                                          y1="35"
                                          x2="35"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </td>
                                <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap ">
                                    {/* {item.firmaotro} */}
                                    {item.firmaotro === 'Si' ? (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        {/* Círculo de fondo */}
                                        <circle cx="50" cy="50" r="50" fill="#4caf50" />
                                        {/* Línea de verificación */}
                                        <polyline
                                          points="30,50 45,65 70,40"
                                          fill="none"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        <circle cx="50" cy="50" r="50" fill="#ff7043" />
                                        <line
                                          x1="35"
                                          y1="35"
                                          x2="65"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="65"
                                          y1="35"
                                          x2="35"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </td>
                                
                            </tr>
                        ))
                        :
                        <tr className="divide-y divide-slate-700 ">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><Loading/></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                    }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
    {modalOnEditarYFirmarConsentimientoInformado? <ModalEditarConsentimientoInformado setmodalOnEditarYFirmarConsentimientoInformado={setmodalOnEditarYFirmarConsentimientoInformado} dataUnConsentimientoInformado={dataUnConsentimientoInformado} setactualizarData={setactualizarData}/>:null}
    {descargarPDFConsentimientoInformado? <ModalConfirmarDescargaPDFConsentimientoInformado setdescargarPDFConsentimientoInformado={setdescargarPDFConsentimientoInformado} dataUnConsentimientoInformado={dataUnConsentimientoInformado}/>:null}
    {modalOnInhabilitarConsentimiento? <ModalInhabilidarConsentimientoInformado setmodalOnInhabilitarConsentimiento={setmodalOnInhabilitarConsentimiento} dataUnConsentimientoInformado={dataUnConsentimientoInformado} setactualizarData={setactualizarData}/>:null}
    
  </div>
  )
}

export default ModalConsentimientosDeUnUsuario